module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp3_1.bd51d47f.png";